export default "__VITE_ASSET__DQDsYEHc__"